import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { Fetch } from "../../../shared/Fetch";
import { JVDate } from "../../../shared/JVDate";
import { IUsersDropdown, ICompanyMastDropdown, IBranchMastDropdown, ITeamsDropdown } from "../../../models/IDropdown";
import { JVDropdown } from "../../../shared/JVDropdown";
import { useEffect, useState } from "react";

export interface IFloatSalEffFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    company?: number | null,
    branch?: number | null,
    team?: number | null,
    salesManager?: number | null,
    activeUser?: boolean | null,
    isFilter?: number | null,
}

export const EmptySalEffFilter: IFloatSalEffFilter = {
    fromDate: new Date,
    toDate: new Date,
    company: null,
    branch: null,
    team: null,
    salesManager: null,
    isFilter: null,
}

interface Iprops {
    // open: boolean,
    // hideDialog: () => void,
    // toast: any,
    salEffFilter: IFloatSalEffFilter,
    setSalEffFilter: (salEffFilter: IFloatSalEffFilter) => void
}

export const Filter = (props: Iprops) => {
    const [company, setCompany] = useState<Array<ICompanyMastDropdown>>();
    const [branch, setBranch] = useState<Array<IBranchMastDropdown>>();
    const [team, setTeam] = useState<Array<ITeamsDropdown>>();
    const [sm, setSM] = useState<Array<IUsersDropdown>>();


  
    const loadSm = async () => {
        const response = await Fetch("Dropdown/UsersByRole", "GET", null, `role_id=${2}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSM(data);
        }
    }
    const loadTeam = async () => {
        const response = await Fetch("Dropdown/teams", "GET", null, null, null);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            const emptyData = {
                team_ID: 0,
                team_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setTeam(data);
        }
    }
    const loadBranch = async () => {
        const response = await Fetch("Dropdown/Branches", "GET", null, null, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranch(data);
        }
    }
    const loadCompany = async () => {
        const response = await Fetch("Dropdown/company", "GET", null, '', null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompany(data);
        }
    }

    useEffect(() => {
        loadSm();
        loadTeam();
        loadBranch();
        loadCompany();
    }, []);

    const { control, handleSubmit, reset } = useForm<IFloatSalEffFilter>({
        defaultValues: props.salEffFilter,
        shouldFocusError: false
    });

    const searchToDB = async (body: IFloatSalEffFilter) => {
        // onHide();
        let filterData: any = body;
        let emptyFilter: any = EmptySalEffFilter;
        for(let key in filterData){
            if(filterData[key] === "-- SELECT --" || filterData[key] === 0){
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setSalEffFilter(body);
    }

    // const onHide = () => {
    //     props.hideDialog();
    // }

    function onSubmit(data: IFloatSalEffFilter) {
        let newDate = new Date;
        if (data.fromDate?.toDateString() !== newDate.toDateString() || (data.company !== null && data.company !== 0) || (data.branch !== null && data.branch !== 0) || (data.team !== null && data.team !== 0) || (data.salesManager !== null && data.salesManager !== 0)) {
            data.isFilter = 1;
        } else {
            data.isFilter = null;
        }
        searchToDB(data);
    }

    return (
        // <Dialog visible={props.open} style={{ width: '80vw' }} header="Search Sales Efficiency" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
                <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
                <JVDropdown column={6} label="Company" control={control} name="company" options={company} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
                <JVDropdown column={6} label="Branch " control={control} name="branch" options={branch} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />
                <JVDropdown column={6} label="Team" control={control} name="team" options={team} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Team" />
                <JVDropdown column={6} label="Sales Manager" control={control} name="salesManager" options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager" />
                <div style={{ margin: '10px 0', width: '100%' }}></div>

                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptySalEffFilter) }} type="button"></Button>
                </div>
            </form>
    );
}
